import React from "react";
import { ArrowDownLeft, ArrowUpRight, RotateCcw, Landmark, AlertTriangle } from "lucide-react";
import { txTypeLabel } from "@/lib/format";

export const TransactionTypeIcon = ({ type, direction }) => {
  if (type === "Refund") return <RotateCcw className="w-4 h-4 text-amber-600" />;
  if (type === "Fund") return <Landmark className="w-4 h-4 text-blue-600" />;
  if (type === "DisputeHold") return <AlertTriangle className="w-4 h-4 text-red-600" />;
  return direction === "In" ? <ArrowDownLeft className="w-4 h-4 text-emerald-600" /> : <ArrowUpRight className="w-4 h-4 text-blue-600" />;
};

export const txTypePretty = (t) => {
  const m = { Fund: "Escrow funded", Release: "Payment released", Split: "Payment released", Refund: "Refund", DisputeHold: "Dispute hold", Invoice: "Invoice paid" };
  return m[t] || txTypeLabel(t);
};
